import { createRoute } from '@tanstack/react-router';
import { onboardingParentRoute } from 'pages/shared/Onboarding/onboardingParentRoute';

export const onboardingLabUnavailableRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  path: '/lab_unavailable',
}).lazy(() =>
  import('pages/shared/Onboarding/LabUnavailable/LabUnavailablePage').then((d) => d.Route)
);
